import styled from '@emotion/native';
import { MARGIN } from 'design-system';

export const BaseWrapper = styled.View({
  margin: MARGIN['2xs'],
});
